import { render, staticRenderFns } from "./emailSettings.vue?vue&type=template&id=1d6c9c44&scoped=true&"
import script from "./emailSettings.vue?vue&type=script&lang=js&"
export * from "./emailSettings.vue?vue&type=script&lang=js&"
import style0 from "./emailSettings.vue?vue&type=style&index=0&id=1d6c9c44&prod&lang=scss&"
import style1 from "./emailSettings.vue?vue&type=style&index=1&id=1d6c9c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c9c44",
  null
  
)

export default component.exports